import { BrowserRouter } from 'react-router-dom';
import { reactOnCms } from 'common/js/react_on_cms';
import { getSeaLinkBasename } from 'utils/helpers';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import './scss/app.scss';
import './images/index';
import './favicons/index';
import './js/nav';
import '../common/js/notifications';
import '../common/rollbar';
import '../common/js/salesforce';
import '../common/js/promotional_banner';
import './js/accordion-toggle-all-button';
import './js/formie-form';
import { ConnectedHeaderIconsWrapper as HeaderIcons } from 'tenants/sealink/header_icons';
import { ConnectedNavigationBar as NavigationBar } from 'tenants/sealink/navigation_bar';
import { ConnectedUserNavigationButtons as UserNavigationButtons } from 'tenants/sealink/navigation_mobile';
import MobileSearch from 'tenants/sealink/navigation_mobile/mobile_search';
import TenantSwitchWarning from 'tenants/sealink/tenant_switch_warning';

window.Offcanvas = Offcanvas;
window.BsModal = Modal;

reactOnCms.register({
  HeaderIcons,
  MobileSearch,
  UserNavigationButtons,
  NavigationBar,
  TenantSwitchWarning,
});

const basename = getSeaLinkBasename();
reactOnCms.addWrapper({
  reactElement: BrowserRouter,
  reactProps: { basename },
});
